import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';

export const SettingsPanelButton = React.memo((props: TopNavBarButtonProps) => (
	<TopNavBarButtonComponent {...props}>
		<SettingsIcon fontSize={'small'}/>
		{props.btnDef?.label && <>&nbsp;{props.btnDef?.label}</>}
	</TopNavBarButtonComponent>
));